import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6181ea1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nfo" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "tel:802-771-5356",
    class: "phone"
  }, "802.771.5356"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "mailto:bob@purpledoorvt.com",
    class: "email"
  }, "bob@purpledoorvt.com")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
  /*#__PURE__*/_createTextVNode(" Purple Door Collaborative is a family owned real estate company developing residential properties in the Burlington Vermont area. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Come see what we've made: ")
], -1))
const _hoisted_4 = { class: "properties" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_test = _resolveComponent("header-test")!
  const _component_Properties = _resolveComponent("Properties")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_header_test, { class: "header" }),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Properties)
    ])
  ]))
}